<template>
  <b-tab ref="tabCommunityComponent" title="Community" lazy>
    <div slot="title">
      <span class="font-size-md active">Community</span>

      <div class="divider"></div>
    </div>
    <router-link
      :to="{
        name: 'community-rules'
      }"
      target="_blank"
    >
      <div ref="buttonCommunityRules" class="grid-container button-list__community-rules">
        <font-awesome-icon
          :icon="{ prefix: 'fas', iconName: 'flag' }"
          style="color: var(--primary); width: 16px; height: 16px"
        />
        <span class="text-topic">Community Rules & Guidelines</span>
      </div>
    </router-link>
    <ForumsList
      ref="ForumListComponent"
      :section-id="sectionId"
      :learning-unit-id="learningUnit.id"
      :forums="forums"
    />
  </b-tab>
</template>

<script>
import ForumsList from './ForumsList.vue';
import LearningUnit from '@/models/LearningUnit';
import { faFlag } from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faFlag);

import Forum from '@/models/Forum';
export default {
  components: {
    ForumsList,
    FontAwesomeIcon
  },
  props: {
    sectionId: {
      type: Number,
      required: true
    },
    learningUnit: {
      type: LearningUnit,
      required: true
    }
  },
  data() {
    return {
      forums: []
    };
  },
  mounted() {
    this.fetch();
  },
  methods: {
    async fetch() {
      try {
        const { response } = await Forum.api().fetchForumsBySection(this.sectionId);
        const { data = [] } = response;
        this.forums = data;
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style scoped>
.button-list__community-rules {
  margin: 10px;
  padding: 20px;
  border: 1px solid rgba(122, 123, 151, 0.3);
  box-shadow: 0px 4px 8.8px rgba(166, 166, 185, 0.55);
  border-radius: 10.4px;
}
.text-topic {
  font-weight: bold;
  margin-left: 16px;
  color: #3b3e66;
}
</style>
